export default __webpack_public_path__ + "static/media/001-museum ticket.ccffc080.svg";